import React from "react";
import SwaggerUI from "swagger-ui-react";
import Header from "../../../components/Header";
import PasswordShowHide from "../../../components/PasswordShowHide";
import Firebase from "../../../firebasehelper";
import "swagger-ui-react/swagger-ui.css";
import "./index.css";

import ApiJSON from "../../../Constants/swagger.json";

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      domain: [],
      loading: false,
      agencies: [],
      brand_name: "",
      brand_url: "",
      communityMembers: [],
      tab: "Community Members",
      searchKey: "",
      searchStatus: "",
      private_token: "",
    };
  }
  componentDidMount() {
    if (!this.props.location.state) this.props.history.push("/");
    else {
      const { brand, role, username } = this.props.location.state;
      const private_token = localStorage.getItem("uid");
      this.setState({ username, role, brand, loading: true, private_token });
      Firebase.getBrandDataByID(brand, (res) => {
        this.setState({
          logo: res.logo,
          icon: res.icon,
          brand_name: res.name,
          brand_url: res.url,
          hex: res.hex,
          loading: false,
          is_property_brand: res.is_property_brand
            ? res.is_property_brand
            : false,
        });
      });
    }
  }

  render() {
    const { username, role, logo, brand, private_token } = this.state;
    return (
      <div id="page-container">
        <Header username={username} role={role} logo={logo} brand={brand} />
        <main
          id="main-container"
          style={{ maxWidth: 1460, width: "100%", alignSelf: "center" }}
        >
          <PasswordShowHide password={private_token}></PasswordShowHide>
          <SwaggerUI spec={ApiJSON} />
        </main>
      </div>
    );
  }
}
export default Home;



// WEBPACK FOOTER //
// ./src/screens/DeveloperIntegration/Api/index.js